import React from 'react';
import './Button.css';

export type ButtonVariant = 'primary' | 'success' | 'secondary' | 'danger';
export type ButtonSize = 'small' | 'medium' | 'large';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    loading?: boolean;
    fullWidth?: boolean;
    iconOnly?: boolean;
    children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
    variant = 'primary',
    size = 'medium',
    loading = false,
    fullWidth = false,
    iconOnly = false,
    disabled,
    className = '',
    children,
    ...props
}) => {
    const classes = [
        'Button',
        `Button--${variant}`,
        `Button--${size}`,
        fullWidth && 'Button--fullWidth',
        iconOnly && 'Button--iconOnly',
        loading && 'Button--loading',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classes}
            disabled={disabled || loading}
            {...props}
        >
            {loading && <span className="Button-spinner" />}
            <span className={loading ? 'Button-content--loading' : 'Button-content'}>
                {children}
            </span>
        </button>
    );
};

export default Button;
